var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6132 3.82775C16.0776 3.30492 16.4316 2.69763 16.655 2.04075C16.8785 1.38387 16.9669 0.690347 16.9152 0C15.4897 0.112417 14.1664 0.767416 13.2305 1.82388C12.7823 2.33022 12.4427 2.91926 12.2317 3.55614C12.0208 4.19301 11.9427 4.86477 12.0023 5.53163C12.6976 5.53729 13.385 5.38656 14.0112 5.09109C14.6373 4.79563 15.1855 4.36336 15.6132 3.82775ZM18.7084 12.7552C18.7166 11.8357 18.9645 10.9335 19.4287 10.1336C19.8929 9.33368 20.558 8.66253 21.3613 8.18346C20.8543 7.46979 20.1841 6.88134 19.4038 6.46478C18.6235 6.04822 17.7546 5.815 16.866 5.78362C14.95 5.59163 13.1814 6.87554 12.1619 6.87554C11.1425 6.87554 9.7055 5.80761 8.10882 5.83161C7.06499 5.86521 6.04789 6.16253 5.15672 6.69458C4.26556 7.22663 3.53075 7.97525 3.02398 8.86741C0.862311 12.5392 2.47128 17.9988 4.63295 20.9626C5.61553 22.4145 6.84375 24.0584 8.465 23.9984C10.0863 23.9384 10.6144 23.0145 12.4936 23.0145C14.3727 23.0145 14.95 23.9984 16.5467 23.9624C18.1434 23.9264 19.2733 22.4745 20.3051 21.0226C21.0359 19.9685 21.6068 18.8167 22 17.6028C21.0266 17.1973 20.1961 16.522 19.6112 15.6605C19.0262 14.799 18.7123 13.789 18.7084 12.7552Z",
    fill: "#11142D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a36e4ade0b6485565b839eef6d3453ff.svg";
export { ForwardRef as ReactComponent };